import { SITE } from '@/app/constants';

const CN = 'https://image01-aliyun.vidu.zone/vidu/media-asset';
const GLOBAL = 'https://image01.cf.vidu.studio/vidu/media-asset';
const BASE = SITE === 'china' ? CN : GLOBAL;

export const HERO_BUBBLE_AVATARS = [
  `${BASE}/hero-bubble-01-bd1e3680.webp`,
  `${BASE}/hero-bubble-02-418d6583.webp`,
  `${BASE}/hero-bubble-03-d9917a14.webp`,
  `${BASE}/hero-bubble-04-8d136497.webp`,
  `${BASE}/hero-bubble-05-83aef075.webp`,
];

export const FEATURE_IMAGES = {
  f1: `${BASE}/feature-1-characters-476b8061.webp`,
  f2: `${BASE}/feature-2-voice-0e82197a.webp`,
  f3: `${BASE}/feature-3-custom-9714a037.webp`,
  f4: `${BASE}/feature-4-unlimited-0bd8acf5.webp`,
};

// 「如何使用 Vidu S」三步配图，按显示顺序排列。国内/海外为不同文件与域名，各自独立维护。
const STEP_IMAGES_CN = [
  'https://image01-aliyun.vidu.zone/vidu/media-asset/11-50216402.webp',
  'https://image01-aliyun.vidu.zone/vidu/media-asset/22-4eb573ad.webp',
  'https://image01-aliyun.vidu.zone/vidu/media-asset/33-7c2f6f9d.webp',
];
const STEP_IMAGES_GLOBAL = [
  'https://image01.cf.vidu.studio/vidu/media-asset/1-dd46c9fb.webp',
  'https://image01.cf.vidu.studio/vidu/media-asset/2-b0685aa1.webp',
  'https://image01.cf.vidu.studio/vidu/media-asset/3-8b66093b.webp',
];
export const STEP_IMAGES = SITE === 'china' ? STEP_IMAGES_CN : STEP_IMAGES_GLOBAL;

export const NEW_CHARACTER_ICON = `${BASE}/new-character-icon-167392a3.webp`;
export const UPLOAD_PHOTO_PLACEHOLDER = `${BASE}/upload-photo-placeholder-a780b492.webp`;
export const UPLOAD_TIPS_DEMO_1 = `${BASE}/demo1-02ae3515.webp`;
export const UPLOAD_TIPS_DEMO_2 = `${BASE}/demo2-a7cd19f3.webp`;

export interface HeroVideoSource {
  src: string;
  poster: string;
}

// 应用案例品类。'all' 仅用于 tab 展示（显示全部），不作为视频归属。
export const USE_CASE_CATEGORIES = ['all', 'funChat', 'sceneInteraction', 'screenCompanion', 'ecommerce'] as const;
export type UseCaseCategory = (typeof USE_CASE_CATEGORIES)[number];
export type UseCaseVideoCategory = Exclude<UseCaseCategory, 'all'>;

export interface UseCaseVideo extends HeroVideoSource {
  category: UseCaseVideoCategory;
}

// 中文环境 hero 区按顺序轮播的视频 + 封面。
export const HERO_VIDEO_SOURCES_ZH: HeroVideoSource[] = [
  { src: `${BASE}/s1-02-man-ae173090.mp4`, poster: `${BASE}/s1-02-man-6df48292.webp` },
  { src: `${BASE}/s1-03-character-a13fec0f.mp4`, poster: `${BASE}/s1-03-character-97686b40.webp` },
  { src: `${BASE}/s1-04-tiger-35e7e7e4.mp4`, poster: `${BASE}/s1-04-tiger-12c54a4a.webp` },
  { src: `${BASE}/狐妖%202-dec4f999.mp4`, poster: `${BASE}/s1-05-extra-07547ef5.webp` },
  { src: `${BASE}/s1-01-woman-2844cb03.mp4`, poster: `${BASE}/s1-01-woman-7d1d2d96.webp` },
];

// 非中文环境使用英文配音版本（去掉第 5 个视频，4 条）。
// 注：第一个「比心」视频用中文同款（无 -en）。
export const HERO_VIDEO_SOURCES_EN: HeroVideoSource[] = [
  { src: `${BASE}/s1-02-man-ae173090.mp4`, poster: `${BASE}/s1-02-man-6df48292.webp` },
  { src: `${BASE}/s1-03-character-en-e4cae5f6.mp4`, poster: `${BASE}/s1-03-character-en-bec26a9f.webp` },
  { src: `${BASE}/s1-04-tiger-en-51f3b813.mp4`, poster: `${BASE}/s1-04-tiger-en-48fe519f.webp` },
  { src: `${BASE}/s1-05-extra-en-bae29bd6.mp4`, poster: `${BASE}/s1-05-extra-en-133908b8.webp` },
];

const ALIYUN = 'https://image01-aliyun.vidu.zone/vidu/media-asset';

// 新增案例：国内与海外为不同文件（海外为英文配音版），各自独立维护。
// 国内每条视频 CDN 上另有 1080p~4K 高清版，案例卡为小尺寸横滑卡片，这里统一取 720×1280 版本以控制流量。
// TODO: category 为临时归类，待产品确认各视频所属品类后调整。
const USE_CASE_VIDEOS_CN: UseCaseVideo[] = [
  {
    src: `${ALIYUN}/20260814-141948-bd6f9d8b.mp4`,
    poster: `${ALIYUN}/20260814-141948-0e680586.webp`,
    category: 'funChat',
  },
  {
    src: `${ALIYUN}/20260814-141951-df72a855.mp4`,
    poster: `${ALIYUN}/20260814-142132-88809f05.webp`,
    category: 'sceneInteraction',
  },
  { src: `${ALIYUN}/s16-4d7810ab.mp4`, poster: `${ALIYUN}/s16-a99f6b0c.webp`, category: 'funChat' },
  { src: `${ALIYUN}/s15-ea43cefe.mp4`, poster: `${ALIYUN}/s15-0b50e4c2.webp`, category: 'sceneInteraction' },
  { src: `${ALIYUN}/s14-0479cd09.mp4`, poster: `${ALIYUN}/s14-0658463a.webp`, category: 'screenCompanion' },
  { src: `${ALIYUN}/s11-9803fc51.mp4`, poster: `${ALIYUN}/s11-e3e8d08c.webp`, category: 'ecommerce' },
  { src: `${ALIYUN}/s12-496fbda9.mp4`, poster: `${ALIYUN}/s12-063a772d.webp`, category: 'funChat' },
  { src: `${ALIYUN}/s13-5ec1d34b.mp4`, poster: `${ALIYUN}/s13-6020df0e.webp`, category: 'sceneInteraction' },
];

const USE_CASE_VIDEOS_GLOBAL: UseCaseVideo[] = [
  { src: `${GLOBAL}/s15en-1a16cbbf.mp4`, poster: `${GLOBAL}/s15en-dc63f687.webp`, category: 'sceneInteraction' },
  { src: `${GLOBAL}/s14en-02970307.mp4`, poster: `${GLOBAL}/s14en-ebde40aa.webp`, category: 'screenCompanion' },
  { src: `${GLOBAL}/s12en-5f5772bd.mp4`, poster: `${GLOBAL}/s12en-c4234ed5.webp`, category: 'funChat' },
  { src: `${GLOBAL}/s13en-79d3cad3.mp4`, poster: `${GLOBAL}/s13en-b515530d.webp`, category: 'sceneInteraction' },
];

// 原有案例：CN 与海外为同名文件、仅域名不同，走 BASE 分流。
const USE_CASE_VIDEOS_LEGACY: UseCaseVideo[] = [
  { src: `${BASE}/stream-6-7b9b4a02.mp4`, poster: `${BASE}/stream-6-dee008e1.webp`, category: 'funChat' },
  { src: `${BASE}/stream-5-f3a9e7be.mp4`, poster: `${BASE}/stream-5-3c632ab8.webp`, category: 'sceneInteraction' },
  { src: `${BASE}/stream-4-43fde783.mp4`, poster: `${BASE}/stream-4-0c68eac7.webp`, category: 'screenCompanion' },
  { src: `${BASE}/stream-3-0d5d805d.mp4`, poster: `${BASE}/stream-3-18445908.webp`, category: 'ecommerce' },
  { src: `${BASE}/stream-2-78dc9fe4.mp4`, poster: `${BASE}/stream-2-d23a2d06.webp`, category: 'funChat' },
  { src: `${BASE}/stream-1-0c3978c9.mp4`, poster: `${BASE}/stream-1-8b86daf3.webp`, category: 'sceneInteraction' },
];

// 应用案例区：新增案例排在前，原有案例接在后。
export const USE_CASE_VIDEOS: UseCaseVideo[] = [
  ...(SITE === 'china' ? USE_CASE_VIDEOS_CN : USE_CASE_VIDEOS_GLOBAL),
  ...USE_CASE_VIDEOS_LEGACY,
];
